const narrativeNumberingOptions = {
  OUTLINE_STYLE: "OUTLINE_STYLE",
  CONTINUOUS_STYLE: "CONTINUOUS_STYLE"
};

export default narrativeNumberingOptions;

export const labelForNarrativeNumberingOption = value => {
  switch (value) {
    case narrativeNumberingOptions.OUTLINE_STYLE:
      return "Outline Style (e.g. Scene 1.1.1)";
    case narrativeNumberingOptions.CONTINUOUS_STYLE:
      return "Book/Continuous Style (e.g. Scene 7)";
  }
};

export const descriptionForNarrativeNumberingOption = value => {
  switch (value) {
    case narrativeNumberingOptions.OUTLINE_STYLE:
      return "Items are numbered using their index at each level of the narrative tree";
    case narrativeNumberingOptions.CONTINUOUS_STYLE:
      return "Items for each section type are numbered independently. Numbering is continuous across parents";
  }
};

const createNarrativeNumberingDropdownOption = id => {
  return {
    identifier: id,
    name: labelForNarrativeNumberingOption(id),
    description: descriptionForNarrativeNumberingOption(id)
  };
};

export const NarrativeNumberingDropdownOptions = [
  createNarrativeNumberingDropdownOption(narrativeNumberingOptions.OUTLINE_STYLE),
  createNarrativeNumberingDropdownOption(narrativeNumberingOptions.CONTINUOUS_STYLE)
];
